import { SurveySegment } from "..";

export const PortalSharedResourceTypes = [
    'DocumentArchiveFile',
    'SurveyReport',
    'ExternalLink'
] as const;

export type PortalSharedResourceType = typeof PortalSharedResourceTypes[number];

// ----------- Update types --------------------------------------------------

export type DocumentArchivePortalSharedResourceConfig = {
    note:string
};
export type DocumentArchivePortalSharedResourceSpec = {
    resourceType: 'DocumentArchiveFile',
    config: DocumentArchivePortalSharedResourceConfig
};

export type SurveyReportPortalSharedResourceConfig = {
    segmentFilter:SurveySegment[][]
};
export type SurveyReportPortalSharedResourceSpec = {
    // Note that resourceId for a surveyReport is the surveyId - not the surveyReportId, since the report will be generated on demand based on the surveyId and the segmentFilter config
    resourceType: 'SurveyReport',
    config: SurveyReportPortalSharedResourceConfig
};

export type ExternalLinkPortalSharedResourceConfig = {}
export type ExternalLinkPortalSharedResourceSpec = {
    resourceType: 'ExternalLink',
    config: ExternalLinkPortalSharedResourceConfig
};

export type PortalSharedResourceSpec =
    DocumentArchivePortalSharedResourceSpec |
    SurveyReportPortalSharedResourceSpec |
    ExternalLinkPortalSharedResourceSpec;


type PortalSharedResourceBase = {
    id: string,
    resourceId: string,
    sharedAt: Date,
    sharedByUserId: string
}

export type PortalSharedDocument = PortalSharedResourceBase & DocumentArchivePortalSharedResourceSpec;
export type PortalSharedSurveyReport = PortalSharedResourceBase & SurveyReportPortalSharedResourceSpec;
export type PortalSharedExternalLink = PortalSharedResourceBase & ExternalLinkPortalSharedResourceSpec;

export type PortalSharedResource = PortalSharedDocument | PortalSharedSurveyReport | PortalSharedExternalLink; // For now we only have one resource type, but this allows us to easily add more in the future without changing the existing type definition


// ----------- Read types --------------------------------------------------

type PortalSharedResourceViewBase = {
    id: string,
    resourceId: string
}

export type PortalSharedDocumentView = PortalSharedResourceViewBase & {
    resourceType: 'DocumentArchiveFile',
    // path:string[], No need for now
    publicFileName:string,
    privateFileName:string,
    sizeBytes:number,
    created: Date,
    note: string
}

export type PortalSharedSurveyReportView = PortalSharedResourceViewBase & {
    resourceType: 'SurveyReport',
    segmentFilter: SurveySegment[][],
    activityTitle:string,
    segmentViewName:string,
    surveyStart: Date,
    surveyEnd:Date
}

export type PortalSharedExternalLinkView = PortalSharedResourceViewBase & {
    resourceType: 'ExternalLink',
    url: string,
    title: string,
    description:string,
    iconName:string | null
}

export type PortalSharedResourceView = 
    PortalSharedDocumentView | PortalSharedSurveyReportView | PortalSharedExternalLinkView; // For now we only have one resource type, but this allows us to easily add more in the future without changing the existing type definition